import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Button } from '@spotahome/ui-library';

import './CallToAction.scss';

const CallToAction = props => {
  const className = classNames('cta', {
    'cta--full': props.full,
    'cta--rounded': props.rounded
  });

  return (
    <Button
      className={className}
      onClick={props.onClick}
      href={props.link}
      size="big"
    >
      {props.children}
    </Button>
  );
};

CallToAction.propTypes = {
  link: PropTypes.string.isRequired,
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  full: PropTypes.bool,
  rounded: PropTypes.bool,
  onClick: PropTypes.func
};

CallToAction.defaultProps = {
  full: false,
  rounded: false,
  onClick: () => {}
};

export default CallToAction;
